import { ExperimentPage } from '~/cf-worker/types';
import { TOP_20_SLUG_REGEX } from '~/features/experiments/ab_project_outcomes_first_plp/constants';

export const experimentedPages: ExperimentPage[] = [
  {
    experimentKey: 'school_lp_redesign',
    name: 'School Landing Page Redesign Feature Flag',
    // Note: as of 5/1/2025, we will only run the new school landing page on non-legacy school lps.
    // Once we have the content ready for the legacy school lps, we can update this regex to include all school lps.
    pathRegex:
      /^\/school\/(?!data-science|business|programming|artificial-intelligence|cybersecurity|product-management|executive-leadership|autonomous-systems|career-resources$).+$/,
    type: 'flag',
  },
  {
    experimentKey: 'masters_lp_hero_takeover',
    name: 'MSAI/MBA Hero Takeover',
    pathRegex: /^\/(masters-artificial-intelligence|mba-ai-product-management)$/,
    type: 'flag',
    options: { expiresAt: '2026-09-11T23:59:59-07:00' }, // Sale ends Sep 11 2026, 23:59:59 PT
  },
  {
    experimentKey: 'claude-engineer-2026',
    name: 'Claude Engineer 2026',
    pathRegex: /^\/(|catalog|experience)$/,
    type: 'flag',
  },
  {
    experimentKey: 'agentic-ai-2026',
    name: 'Agentic AI 2026',
    pathRegex: /^\/$/,
    type: 'flag',
  },
  {
    experimentKey: 'ab_project_outcomes_first_plp',
    name: 'Project-First PLP — Top 20 Redesign',
    pathRegex: TOP_20_SLUG_REGEX,
    type: 'experiment',
  },
];
